import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import { AuthService } from "~app/auth/auth.service";
import { ILayer } from "../../layer/layer.type";
import { MarkerMode } from "../../map.service";

@Injectable({
  providedIn: 'root',
})
export class MapSettingsService {
  public flagLayerFilter = new BehaviorSubject({flagFilterEnabled: false});
  public flagLayerFilter$ = this.flagLayerFilter.asObservable();

  constructor() {}
}
